module.exports = __webpack_public_path__ + "img/cc.ccd20d3e0.svg";